module.exports = __webpack_public_path__ + "img/Profil_CS-Small.e30080fe.jpg";